export const getNumberRemaingMonthsThisYear = (d: string | Date): number => {
    if (typeof d === "string") {
        const date = new Date(d);
        return 12 - date.getMonth();
    } else {
        return 12 - d.getMonth();
    }
};

export const getFullDateUSStyle = (d: Date): string => {
    return d.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric"
    });
}

export const getShortDateUSStyle = (
    d: Date,
): string => {
    return d.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
    });
}

export const todayPlusFormatted = (offsetDays: number): string => {
    const now = new Date();
    const msPerDay = 24 * 60 * 60 * 1000;
    const target = new Date(now.getTime() + offsetDays * msPerDay);

    const year  = target.getFullYear();
    // getMonth() is zero‑based → add 1, then pad to two digits
    const month = String(target.getMonth() + 1).padStart(2, '0');
    const day   = String(target.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
};

export const getNextMonth = () => {
    const d = new Date();
    if (d.getMonth() === 11) {
        d.setMonth(0);
        d.setFullYear(d.getFullYear() + 1);
    } else {
        d.setMonth(d.getMonth() + 1);
    }
    return d;
}